<div class="page-layout blank flex flex-col">
  <!--<div class="toolbar second-level-toolbar" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="center start" class="grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>-->
  <particle-workflow-wizard [workflowId]="workflowId"
                            [apiEndpointKey]="apiEndpointKey"
                            (GridCellValueChanged)="onGridCellValueChange($event)">
  </particle-workflow-wizard>
</div>


